"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachePolicyHttpCacheSemanticsWrapper = void 0;
const bus_http_1 = require("@comunica/bus-http");
const context_entries_1 = require("@comunica/context-entries");
/**
 * Wrapper over the cache policy of http-cache-semantics to expose it as an ICachePolicy.
 */
class CachePolicyHttpCacheSemanticsWrapper {
    cachePolicy;
    queryTimestamp;
    fetchInitPreprocessor;
    constructor(cachePolicy, queryTimestamp, fetchInitPreprocessor) {
        this.cachePolicy = cachePolicy;
        this.queryTimestamp = queryTimestamp;
        this.fetchInitPreprocessor = fetchInitPreprocessor;
    }
    storable() {
        return this.cachePolicy.storable();
    }
    async satisfiesWithoutRevalidation(action) {
        // We always allow full caching within the context of a single query execution
        if (this.queryTimestamp && action.context.get(context_entries_1.KeysInitQuery.queryTimestampHighResolution) === this.queryTimestamp) {
            return true;
        }
        // Otherwise, determine through cache policy
        return this.cachePolicy.satisfiesWithoutRevalidation(await CachePolicyHttpCacheSemanticsWrapper
            .convertFromFetchRequest(action, this.fetchInitPreprocessor));
    }
    responseHeaders() {
        return CachePolicyHttpCacheSemanticsWrapper.convertToFetchHeaders(this.cachePolicy.responseHeaders());
    }
    timeToLive() {
        return this.cachePolicy.timeToLive();
    }
    async revalidationHeaders(newAction) {
        return CachePolicyHttpCacheSemanticsWrapper.convertToFetchHeaders(this.cachePolicy
            .revalidationHeaders(await CachePolicyHttpCacheSemanticsWrapper
            .convertFromFetchRequest(newAction, this.fetchInitPreprocessor)));
    }
    async revalidatedPolicy(revalidationAction, revalidationResponse) {
        const revalidatedPolicy = this.cachePolicy.revalidatedPolicy(await CachePolicyHttpCacheSemanticsWrapper
            .convertFromFetchRequest(revalidationAction, this.fetchInitPreprocessor), {
            status: revalidationResponse.status,
            headers: revalidationResponse.headers ? bus_http_1.ActorHttp.headersToHash(revalidationResponse.headers) : {},
        });
        return {
            policy: new CachePolicyHttpCacheSemanticsWrapper(revalidatedPolicy.policy, this.queryTimestamp, this.fetchInitPreprocessor),
            modified: revalidatedPolicy.modified,
            matches: revalidatedPolicy.matches,
        };
    }
    static async convertFromFetchRequest(request, fetchInitPreprocessor) {
        let headers = typeof request.input === 'string' ? request.init?.headers : request.input.headers;
        headers = (await fetchInitPreprocessor.handle({ headers }, request.context)).headers;
        return {
            url: typeof request.input === 'string' ? request.input : request.input.url,
            method: request.init?.method ?? 'GET',
            headers: headers ? bus_http_1.ActorHttp.headersToHash(new Headers(headers)) : {},
        };
    }
    static convertToFetchHeaders(headers) {
        const fetchHeaders = new Headers();
        for (const [key, value] of Object.entries(headers)) {
            if (Array.isArray(value)) {
                for (const valueEntry of value) {
                    fetchHeaders.append(key, valueEntry);
                }
            }
            else if (value) {
                fetchHeaders.append(key, value);
            }
        }
        return fetchHeaders;
    }
}
exports.CachePolicyHttpCacheSemanticsWrapper = CachePolicyHttpCacheSemanticsWrapper;
//# sourceMappingURL=CachePolicyHttpCacheSemanticsWrapper.js.map